import React from 'react';
import {
    RadarChart,
    Radar,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    ResponsiveContainer,
    Tooltip,
    Legend
} from 'recharts';
import { COLORS } from '../../constants';

export const RadarChartComponent = ({ data, legend, theme }) => {
    const CustomTick = ({ payload, x, y, textAnchor, stroke }) => (
        <g>
            <text
                x={x}
                y={y}
                textAnchor={textAnchor}
                fill={theme.palette.text.primary}
                style={{
                    fontSize: '12px',
                    fontFamily: theme.typography.fontFamily,
                    fontWeight: 500
                }}
            >
                {payload.value.length > 20 
                    ? `${payload.value.substring(0, 20)}...`
                    : payload.value}
            </text>
        </g>
    );

    return (
        <ResponsiveContainer width="100%" height={500}>
            <RadarChart data={data} margin={{ top: 20, right: 30, left: 30, bottom: 20 }}>
                <PolarGrid stroke={theme.palette.grey[300]} />
                <PolarAngleAxis
                    dataKey="text"
                    tick={CustomTick}
                />
                <PolarRadiusAxis
                    angle={30}
                    domain={[0, 100]}
                    tick={{
                        fill: theme.palette.text.secondary,
                        fontSize: 12
                    }}
                    tickFormatter={(value) => `${value}%`}
                />
                {legend.map((item, index) => (
                    <Radar
                        key={item.name}
                        name={item.name}
                        dataKey={`ats[${index}].val`}
                        stroke={COLORS[index % COLORS.length]}
                        fill={COLORS[index % COLORS.length]}
                        fillOpacity={0.3}
                    />
                ))}
                <Tooltip
                    formatter={(value) => `${value?.toFixed(1)}%`}
                    contentStyle={{
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        borderRadius: 4,
                        boxShadow: theme.shadows[3],
                        border: 'none'
                    }}
                />
                <Legend />
            </RadarChart>
        </ResponsiveContainer>
    );
};
